export const DULeadData = [
  {
    duleadName: "Aastha Bajaj",
    duleadProject: "UKI",
    duleadMarket: "Products&platform",
    duleadImage: "images/testimonial/du-lead/AasthaBajaj.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_0jt78p66/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Abhisek Pradhan",
    duleadProject: "SAP",
    duleadMarket: "Pro",
    duleadImage: "images/testimonial/du-lead/AbhisekPradhan.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_et8d4qlg/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Badrinarayan Damal",
    duleadProject: "SI",
    duleadMarket: "Growth Market",
    duleadImage: "images/testimonial/du-lead/BadrinarayanDamal.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_dx3862he/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Deepali Kulkarni",
    duleadProject: "Engie S4 HANA",
    duleadMarket: "Europe",
    duleadImage: "images/testimonial/du-lead/DeepaliKulkarni.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_brx6kpry/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Guru Arali",
    duleadProject: "SAPS4",
    duleadMarket: "NA",
    duleadImage: "images/testimonial/du-lead/GuruArali.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_1vss0spo/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Kedar Panandikar",
    duleadProject: "British Telecom",
    duleadMarket: "Digital",
    duleadImage: "images/testimonial/du-lead/KedarPanandikar.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_auy7h6ng/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Laxminarayan",
    duleadProject: "Travelers",
    duleadMarket: "NA",
    duleadImage: "images/testimonial/du-lead/Laxminarayan.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_qnew6zrh/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Sarang Joshi",
    duleadProject: "Europe",
    duleadMarket: "ATCi",
    duleadImage: "images/testimonial/du-lead/SarangJoshi.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_cius58k4/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Suganya Ganesan",
    duleadProject: "Devon",
    duleadMarket: "Energy",
    duleadImage: "images/testimonial/du-lead/SuganyaGanesan.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_x2f4dos1/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Sumit Dayal",
    duleadProject: "ARC",
    duleadMarket: "AAME",
    duleadImage: "images/testimonial/du-lead/SumitDayal.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_3n2oad94/uiConfId/27188232/st/0",
  },
  {
    duleadName: "Vijay Arugadoss",
    duleadProject: "ASG Resources",
    duleadMarket: "Europe",
    duleadImage: "images/testimonial/du-lead/VijayArugadoss.png",
    duleadVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_9yilcxmm/uiConfId/27188232/st/0",
  },
];
